module.exports = __webpack_public_path__ + "aff28a207631f39ee0272d5cdde43ee7.svg";


//////////////////
// WEBPACK FOOTER
// ./~/onsenui/css/ionicons/fonts/ionicons.svg
// module id = 303
// module chunks = 1